<template>
  <form @submit.prevent="subscribe">
    <div class="form-section">
      <input type="text" v-model="name" required="true" class="mp-input" placeholder="Name" />
    </div>

    <div class="form-section">
      <input type="email" v-model="email" required="true" class="mp-input" placeholder="Email Address" />
    </div>

    <div class="form-section">
      <button type="submit" class="mp-button" :disabled="loading">Submit</button>
    </div>

    <div v-if="error" class="message nord color-red" v-html="error"></div>
    <div v-if="success" class="message nord color-red">Subscribed!</div>
    <div v-if="loading" class="message nord">Subscribing…</div>
  </form>
</template>

<script>
import Airtable from 'airtable'
import EmailValidator from 'email-validator'

export default {
  name: 'AirtableSubscribe',
  data() {
    return {
      name: '',
      email: '',
      error: '',
      success: false,
      loading: false,
      base: null,
      table: null,
    }
  },
  methods: {
    async subscribe() {
      this.loading = true
      this.error = ''

      // check if email is okay
      if (!EmailValidator.validate(this.email)) {
        this.error = 'Please enter a valid email address.'
        return
      }

      const res = await fetch(`${process.env.VUE_APP_API_URL}/airtable`, {
        method: 'POST',
        body: JSON.stringify({
          name: this.name,
          email: this.email,
        }),
      })

      if (res.ok) {
        const data = await res.json()

        // console.log(data)

        this.success = true
        this.loading = false

        setTimeout(() => {
          this.success = false
          this.email = ''
        }, 1500)
      } else {
        console.error(res)
      }
    },
  },
}
</script>

<style scoped>
form {
  width: 100%;
}

.form-section + .form-section {
  margin-top: 1rem;
}

.form-section input {
  width: 100%;
}

.form-section {
  display: flex;
  justify-content: center;
  align-items: center;
}
.message {
  margin-top: 2rem;
}

@media (max-width: 1000px) {
  form input[type='email'],
  form button {
    grid-column: 1 / -1;
  }
}
</style>
